import { errorMessageFrom } from "../../../../../../../utils/formErrors";
import React,{useState, useEffect} from 'react';
import {Box, Stack, CircularProgress} from '@mui/material';
import TopBar from "../../../../../../../component/TopBar";
import MainBox from "../../../../../container/MainBox";
import ActiveBar from "../../../../../../../component/PolicyNavbarUpdated";
import BtnPrimary from '../../../../../../../component/PrimaryButton';
import BtnSecondary from '../../../../../../../component/SecondaryButton';
import FormField from '../../../../../../../component/Formfield';
import TypeBtn from '../../../../../../../component/AddRemoveButton';
import {getAllExpenseCategory} from "../../../../../../../services/expense";
import { updatePolicy } from '../../../../../../../services/policy';
import { useNotify } from '../../../../../../../component/NotificationProvider';
import { getActiveLegalUnit } from '../../../../../../../services/globalData';
import {useLocation, useNavigate} from "react-router-dom";
import ErrorMsg from '../../../../../../../component/ErrorMsg';
import SetLimit from '../../../../../../../component/SetLimit';
import { tokens } from '../../../../../../../theme';

const AddCategory = () => {

  const [apiCall,setApiCall]=useState(false);
  const navigate = useNavigate();
  const {state} = useLocation();
  const [policyId, setPolicyId] = useState(null);
  const [expenseCategories,setExpenseCategories] = useState([{_id:"",code:"",limits:[]}]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [isLimitDialogOpen, setIsLimitDialogOpen] = useState(false);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null); 
  const [error,setError]=useState("");
  const notify = useNotify();

  useEffect(()=>{
    getExpenseCategoryList();
    setPolicyId(state?.policyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const getExpenseCategoryList = async () => {
    try {
      const legalUnit = getActiveLegalUnit();
      const res = await getAllExpenseCategory(legalUnit?._id);
      const categories = (res.data || []).map(category => ({ value: category._id, name: category.name, code: category.code}));
      setCategoryOptions(categories);
    } catch (error) {
      notify.error(error?.message || "Failed to load expense categories");
    }
  };


    const handleAddExpenseCategory = () =>{
      setExpenseCategories([...expenseCategories,{ _id: "", code: "", limits: [] }])
    }

    const handleRemoveExpenseCategory = (index) => {
      let selectedExpenseCategory = [...expenseCategories];
      selectedExpenseCategory.splice(index, 1);
      setExpenseCategories(selectedExpenseCategory);
    };

    const handleCategorySelection = (index, fieldName, value) => {
      let selectedExpenseCategory = [...expenseCategories];
      selectedExpenseCategory[index][fieldName] = value;
      setExpenseCategories(selectedExpenseCategory);
    };

    //returns corresponding code when an expense is selected
    const getCode = (id) =>{
        return categoryOptions.find((option)=>option.value===id)?.code;  
    }

    const handleSetLimit = (index) => {
      setSelectedCategoryIndex(index); 
      setIsLimitDialogOpen(true);
    };

    const handleLimitDialogClose = (limits) => {
      setIsLimitDialogOpen(false);
      if (limits && selectedCategoryIndex !== null) {
        let updatedExpenseCategories = [...expenseCategories];
        updatedExpenseCategories[selectedCategoryIndex].limits = limits; 
        setExpenseCategories(updatedExpenseCategories);
      }
      setSelectedCategoryIndex(null); 
    };

    const handleNextClick = async() => {
     setApiCall(true);
     try {
          const res = await updatePolicy(policyId,{policyCateogary:expenseCategories});
          if(res.success){
            notify.success("Categories saved");
            navigate("/app/expense-policy/new/assign-policy",{state:{policyId}});
          }else{
            setError(res.message);
            notify.error(errorMessageFrom(res, "Could not save categories"));
          }
      } catch (error) {
          notify.error(error?.message || "Something went wrong saving categories");
      } finally {
          setApiCall(false);
      }
  };

  return (
      <Box sx={{width:"100%"}}>
          <TopBar MainHeading={"Expense Policy"} breadcrumbs={[{label:"Expense Policy", href:"/app/expense-policy/listing"},{label:"Add Category"}]}/>
          <MainBox sx={{ padding: "2rem 1.25rem" }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: "1.5rem" }}>
              <ActiveBar active={["Policy Details","Add Category"]}/>
          </Stack>
          <Box>
            {
              expenseCategories?.map((item,index)=>(
                <Box key={index}>
                  <Box sx={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems:"center" }}>
                    <Box sx={{ width: "90%", display: "flex", justifyContent: "space-between", alignItems:"center" }}>
                        <FormField
                            label="Choose Category"
                            type="select"
                            options={categoryOptions}
                            value={item._id}
                            onChange={(e) => {
                                      handleCategorySelection(index, '_id', e.target.value)
                                      handleCategorySelection(index, 'code', getCode(e.target.value) )
                                    }}
                        />
                        <FormField
                            label="Category Code"
                            type="text"
                            value={item.code}
                            disabled={true}
                        />
                      </Box>
                        <TypeBtn type="remove" onClick={()=>handleRemoveExpenseCategory(index)} sx={{width: '1.125rem', height: '1.125rem'}}>
                        </TypeBtn>
                  </Box>
                  {item?.limits?.length > 0?(
                    <Box sx={{backgroundColor:tokens.surface,borderRadius: "12px",padding: "2rem 1rem", display:"flex", justifyContent:"space-between", marginBottom: "1rem"}}>
                        <Box sx={{fontSize:"1rem",lineHeight: 1.7, display:"flex"}}>
                          {"Expense Limit set to: "} 
                          {item?.limits?.map((limit)=>`${limit?.limit}/${limit?.frequency}`).join(', ')}
                        </Box>
                        <BtnSecondary
                          onClick={() => handleSetLimit(index)}
                          sx={{width:"8.93rem", height:"1.93rem", borderRadius:"10px"}}
                        >
                            Edit Limit
                        </BtnSecondary>
                    </Box>
                  ):(
                    <Box sx={{display:"flex",justifyContent:"end"}}>
                          <BtnSecondary
                            onClick={() => handleSetLimit(index)}
                            sx={{width:"8.93rem", height:"1.93rem", borderRadius:"10px"}}
                            disabled={item.code===""}
                          >
                              Set Limit
                          </BtnSecondary>
                    </Box>
                  )}             
                </Box>
              ))
            }
            <ErrorMsg>{error}</ErrorMsg>
            {(expenseCategories.length===0 || expenseCategories[expenseCategories?.length - 1]?._id !=="")?(
                <TypeBtn type="add" onClick={handleAddExpenseCategory}>
                    Add Category
                </TypeBtn>
            ):null}
          </Box>
          
          <Box sx={{display:"flex", justifyContent:"end", gap: "1rem", marginTop: "2rem"}}>
              <BtnPrimary 
                onClick={handleNextClick} 
                sx={{width:"10rem", height:"3.125rem", borderRadius:"10px"}}
                disabled={apiCall}
              >
                  {apiCall?<CircularProgress/>:"Next"}
              </BtnPrimary>
          </Box>

          <SetLimit
            open={isLimitDialogOpen}
            limits={
              expenseCategories[selectedCategoryIndex]?.limits?.length>0 
              ? expenseCategories[selectedCategoryIndex]?.limits 
              : [{limit:"",frequency:"",instances:"",frequencyType:""}]
            }
            onClose={handleLimitDialogClose}
          />
          </MainBox>
      </Box>
    )
}

export default AddCategory;